import { render, staticRenderFns } from "./ExpressBots.vue?vue&type=template&id=a1087714&scoped=true&"
import script from "./ExpressBots.vue?vue&type=script&lang=js&"
export * from "./ExpressBots.vue?vue&type=script&lang=js&"
import style0 from "./ExpressBots.vue?vue&type=style&index=0&id=a1087714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1087714",
  null
  
)

export default component.exports